const http = uni.$u.http

let data = [];
data.length
/**
 * 被指派行程详情
 * @param data
 * @returns {HttpPromise<any>}
 */
export const getcarDispatch = (data) => http.get('/app/car/dispatch/'+data,);



/**
 * 字典
 * @param data
 * @returns {HttpPromise<any>}
 */
export const getcarType = (data) => http.get('/app/car/type/'+data,);


/**
 * 上传行
 * @param data
 * @returns {HttpPromise<any>}
 */
export const carUploadTrip = (data ={}) => http.post('/app/car/uploadTrip',data)
/**
 * 上传垫付
 * @param data
 * @returns {HttpPromise<any>}
 */
export const carUploadFinance = (data ={}) => http.post('/app/car/uploadFinance',data)

/**
 * 提交甩挂
 * @param data
 * @returns {HttpPromise<any>}
 */
export const carSubmitDropHoo = (data ={}) => http.post('/app/car/submitDropHook',data)




/**
 * 提交接挂
 * @param data
 * @returns {HttpPromise<any>}
 */
export const carSubmitPickHook = (data ={}) => http.post('/app/car/submitPickHook',data)

/**
 * 被行程历史
 * @param data
 * @returns {HttpPromise<any>}
 */
export const tmsTripList = (data) => http.get('/app/car/tmsTripList/'+data,);

/**
 * 历史行程列表

 * @param data
 * @returns {HttpPromise<any>}
 */
export const getAssignedItineraryLogList = (data ={}) => http.get('app/car/assignedItineraryLogList',{params: {...data}});





